import { createSlice } from '@reduxjs/toolkit';

const dark = JSON.parse(localStorage.getItem('user'))?.settings;
const dark_mode = !dark ? false : JSON.parse(dark).darkmode;
export const darkmodeSlice = createSlice({
  name: 'darkmode',
  initialState: {
    darkmode: dark_mode,
  },
  reducers: {
    toggleDarkmode(state) {
      state.darkmode = true;
      localStorage.setItem('theme', state.darkmode);
    },
    toggleDisableDarkmode(state) {
      state.darkmode = false;
      localStorage.setItem('theme', state.darkmode);
    },
    setDarkmode(state, { payload }) {
      state.darkmode = payload;
      localStorage.setItem('theme', state.darkmode);
    },
  },
});

export const { toggleDarkmode, toggleDisableDarkmode, setDarkmode } = darkmodeSlice.actions;
export default darkmodeSlice.reducer;
